/*
 * @Author: Zhouqi
 * @Date: 2025-11-27 15:54:33
 * @LastEditors: Zhouqi
 * @LastEditTime: 2026-01-09
 */
import dynamic from 'next/dynamic';

import { withLayout } from '@/utils/withLayout';

// import Library from './library';
const Library = dynamic(() => import('../../3.0/library/entry'), {
  ssr: false,
});

const LibraryPage: React.FC = () => {
  return <Library />;
};

export default withLayout(LibraryPage);
